import React, {useState, useEffect} from 'react';
import Image from 'app/Components/Shared/Image/image';
import {useSelector} from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import CheckBox from 'app/Components/Shared/CheckBox/Checkbox';
import {useDebtPaymentPopupData} from '../../hooks/useDebtPaymentPopupData';
import {stepEnum, paymentAction} from '../../Constants/debtPaymentEnum';
import {selectSelectedBanData, selectPaymentAmount} from '../../DebtAndUpdatePaymentBlockSlice';
import {isMobile} from 'react-device-detect';
import {dwhBanReport, DwhActionType, DWHMessageText, DWHStatus} from '../../reports/dwhReports';

const PaymentIssueNotification = (props) => {
  const {actions} = useDebtPaymentPopupData();
  const selectedBanData = useSelector(selectSelectedBanData);
  const paymentAmount = useSelector(selectPaymentAmount);
  const loginData = useSelector((state) => state.authentication.loginData);
  const yDaysCount = useSelector((state) => state.debtAndUpdatePayment.paymentStatusDisplayDaysY);
  const yDaysCountEnergy = useSelector((state) => state.debtAndUpdatePayment.energyPaymentStatusDisplayDaysY);
  const [updatePayment, setUpdatePayment] = useState(true);
  const bitPaymentOption = useSelector((state) => state.debtAndUpdatePayment.bitPaymentOption);

  useEffect(() => {
    dwhBanReport({
      banData: selectedBanData,
      loginData,
      paymentAmount,
      actionType: DwhActionType.UpdatePaymentPopUp,
      messageText: DWHMessageText.UpdatePaymentPopUpDisplayed,
      status: DWHStatus.Ongoing,
      yDaysCount,
      yDaysCountEnergy,
    });
  }, []);

  function handleNextStep() {
    if (updatePayment) {
      dwhBanReport({
        banData: selectedBanData,
        loginData,
        paymentAmount,
        actionType: DwhActionType.UpdatePaymentPopUp,
        messageText: DWHMessageText.ContinueWithUpdatePaymentClicked,
        status: DWHStatus.Ongoing,
        yDaysCount,
        yDaysCountEnergy,
      });
      actions.setPaymentAction(paymentAction.PAYMENT_AND_UPDATE);
      actions.setSelectedBansForPaymentUpdate([selectedBanData.banNumber]);
      actions.goToStep(stepEnum.CREDITCARD);
    } else {
      dwhBanReport({
        banData: selectedBanData,
        loginData,
        paymentAmount,
        actionType: DwhActionType.UpdatePaymentPopUp,
        messageText: DWHMessageText.ContinueWithoutUpdatePaymentClicked,
        status: DWHStatus.Ongoing,
        yDaysCount,
        yDaysCountEnergy,
      });
      if (bitPaymentOption) {
        actions.goToStep(stepEnum.SELECTPAYMENTTYPE);
      } else {
        actions.goToStep(stepEnum.CREDITCARD);
      }
    }

    actions.setShowPopup({showPopUp: false});
  }

  function getTitle() {
    if (selectedBanData.paused) {
      return 'כדי לשחרר את החשבון מהחסימה, <br />נדרש גם לעדכן את אמצעי התשלום בחשבון';
    }
    return 'אמצעי התשלום שלך לא מעודכן';
  }

  return (
    <div>
      <div className='debt-payment-popup-image'>
        <Image src={require('../../images/error.svg')} />
      </div>
      <div className={`popup-title ${isMobile ? 'm-title' : 'l-title'}`}>לפני שנתקדם לתשלום החוב</div>
      <div className='popup-text' dangerouslySetInnerHTML={{__html: getTitle()}} />

      <div className='debt-payment-popup-actions'>
        <CheckBox
          id={'debt-payment-popup-check-box'}
          onCheck={(e) => setUpdatePayment(!updatePayment)}
          onUncheck={(e) => setUpdatePayment(!updatePayment)}
          checked={!!updatePayment}
          label={'תעדכנו לי גם את אמצעי התשלום'}
          customClassName='square'
        />
        <BtnSubmit onclick={handleNextStep} text={' בואו נתקדם'} />
      </div>
    </div>
  );
};

export default PaymentIssueNotification;
